/* eslint-disable */

var http = require('../http');

var toExport = {
  addCard: function(sGiftCardNumber, sGiftCardPIN) {
    var params = {
      sGiftCardNumber: sGiftCardNumber,
      sGiftCardPIN: sGiftCardPIN
    };
    return http.post(this.urls.addGiftcard, params).then(function(resp) {
      return JSON.parse(resp.body);
    }, function(resp) {
      throw resp;
    });
  },
  getBasketPrices: function() {
    return http.get(toExport.urls.getBasketPrices).then(function(resp) {
      return JSON.parse(resp.body);
    });
  },
  voucher: {
    add: function(promoCode) {
      return http.post(toExport.urls.controlVoucher.add, {promocode: promoCode}).then(function(resp) {
        return JSON.parse(resp.body)
      });
    },
    remove: function() {
      return http.get(toExport.urls.controlVoucher.remove, {}).then(function(resp) {
        return JSON.parse(resp.body);
      });
    }
  },
  urls: {
    addGiftcard: '',
    getBasketPrices: '',
    controlVoucher: {}
  }
};

module.exports = toExport;
